export enum WarehouseGoodUsageStatus {
  NeverUsage = 'NEVER_USED',
  ConnectedWithOtherObjects = 'CONNECTED_WITH_OTHER_OBJECTS',
}
